import {createContext} from 'react';

export type ValidationError = {
    code: string,
    message: string,
    controlId: string,
    priority?: number,
};

export type ValidationContextType = {
    getErrorsByControlId: (controlId: string) => Array<ValidationError>,
    validationErrors: Array<ValidationError>,
    addError: (error: ValidationError) => void,
    removeError: (controlId: string, codes?: Array<string>) => void,
    clearErrors: () => void,
};

export const ValidationContext = createContext<ValidationContextType>({
    getErrorsByControlId: () => [],
    validationErrors: [],
    addError: () => undefined,
    removeError: () => undefined,
    clearErrors: () => undefined,
});
